import { render, staticRenderFns } from "./e-sign-add-roles-page.vue?vue&type=template&id=5bbdf294"
import script from "./e-sign-add-roles-page.vue?vue&type=script&lang=js"
export * from "./e-sign-add-roles-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports